// extracted by mini-css-extract-plugin
export default {"value":"LendHeader-module__value--maYk5"};